// extracted by mini-css-extract-plugin
export var deleteIcon = "_s4-5";
export var deleteOption = "_s4-3";
export var divider = "_s4-2";
export var downloadIcon = "_s4-4";
export var drawer = "_s4-0";
export var drawerFooter = "_s4-6";
export var drawerOpen = "_s4-1";
export var highlighted = "_s4-7";
export var lighterHighlight = "_s4-8";